import { defineMessage } from 'services/localization';

export const messages = {
    billColumnName: defineMessage('bill'),
    totalAmount: defineMessage('total_amount_totalamount'),
    dateColumnName: defineMessage('date'),
    categoryColumnName: defineMessage('category'),
    accountColumnName: defineMessage('account'),
    taxCodeColumnName: defineMessage('tax_code'),
    taxRateColumnName: defineMessage('tax_rate'),
    taxAmountColumnName: defineMessage('tax_amount'),
    grossAmountColumnName: defineMessage('gross_amount'),
    memoColumnName: defineMessage('memo'),
    departmentColumnName: defineMessage('department'),
    classColumnName: defineMessage('class'),
    locationColumnName: defineMessage('location'),
    isBillableColumnName: defineMessage('billable'),
    descriptionColumnName: defineMessage('description'),
    quantityColumnName: defineMessage('qty'),
    itemColumnName: defineMessage('item'),
    customerColumnName: defineMessage('customer'),
    amountColumnName: defineMessage('amount'),
    unitPriceColumnName: defineMessage('rate'),
    emptyMatching: defineMessage('matched_requesttype_is_not_synced_to_approvalmax'),
    bill: defineMessage('bill'),
    po: defineMessage('po'),
    deleteConfirmationText: defineMessage('sure'),
    deleteButtonTitle: defineMessage('remove_the_matching'),
    remove: defineMessage('remove'),
};
